import { writable } from "svelte/store";
import { type Campaign } from "../../types/campaign";
import merge from "lodash/merge";

export type CampaignStore = {
  campaign?: Campaign;
};

export function updateCampaign(campaignUpdate: Partial<Campaign>) {
  campaignStore.update((data) => {
    return {
      ...data,
      campaign: merge(data?.campaign, campaignUpdate)
    };
  });
}

export function initStore() {
  const store = writable<CampaignStore>();
  store.set({});
  return store;
}

export const campaignStore = initStore();
